import React, { useEffect, useMemo } from 'react'
import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  StyleSheet,
  Linking,
  ActivityIndicator
} from 'react-native'
import Card from '../../components/shared/card/Card'
import { colorPalette, globalStyles } from '../../static/styles/global'
import {
  Ionicons,
  AntDesign,
  FontAwesome,
  Feather,
  Entypo
} from '@expo/vector-icons'
import { boardStyles } from '../../static/styles/board'
import HomeDetailsHeader from '../../components/home/HomeDetailsHeader'
import { usepaycheckStore } from '../../stores/paycheck'
import { useInitializeStore } from '../../stores/initialize'
import ScreenStatus from '../../components/home/ScreenStatus'
import { useTranslation } from 'react-i18next'
import { useHomeStore } from '../../stores/home'

type CardProfileProps = {
  title: string
  subTilte?: string
  icon?: any
  action?: any
  policy?: any
}
const EmployeeResources = ({ navigation, route }) => {
  const CardProfile = ({
    title,
    subTilte,
    icon = '',
    action
  }: CardProfileProps): JSX.Element => {
    return (
      <TouchableOpacity
        onPress={action}
        style={[
          globalStyles.hDirection,
          globalStyles.hBetweenItems,
          globalStyles.vCenterItems,
          styles.CardProfile
        ]}
      >
        <View style={[globalStyles.hDirection, globalStyles.vCenterItems]}>
          {icon.length > 0 && (
            <Feather
              name={icon}
              size={22}
              color="black"
              style={[globalStyles.mr2]}
            />
          )}
          <View style={[globalStyles.vDirection]}>
            <Text
              style={[
                globalStyles.text,
                globalStyles.fwSemiBold,
                globalStyles.primaryTextColor
              ]}
            >
              {title}
            </Text>
            {subTilte && subTilte !== '' && (
              <Text
                style={[
                  globalStyles.text,
                  globalStyles.fs12,
                  globalStyles.primaryTextColor
                ]}
              >
                {subTilte}
              </Text>
            )}
          </View>
        </View>
        {true && (
          <View style={[globalStyles.relativePosition, globalStyles.rn6]}>
            <Entypo
              name="chevron-right"
              size={24}
              color={colorPalette.secondary}
            />
          </View>
        )}
      </TouchableOpacity>
    )
  }
  const CardProfile2 = ({
    title,
    subTilte,
    icon = '',
    action,
    policy
  }: CardProfileProps): JSX.Element => {
    return (
      <TouchableOpacity
        onPress={() => handleView(policy)}
        style={[
          globalStyles.hDirection,
          globalStyles.hBetweenItems,
          globalStyles.vCenterItems,
          styles.CardProfile
        ]}
      >
        <View style={[globalStyles.hDirection, globalStyles.vCenterItems]}>
          {icon.length > 0 && (
            <FontAwesome
              name={icon}
              size={22}
              color="black"
              style={[globalStyles.mr2]}
            />
          )}
          <View style={[globalStyles.vDirection]}>
            <Text
              style={[
                globalStyles.text,
                globalStyles.fwSemiBold,
                globalStyles.primaryTextColor
              ]}
            >
              {title}
            </Text>
            {subTilte && subTilte !== '' && (
              <Text
                style={[
                  globalStyles.text,
                  globalStyles.fs12,
                  globalStyles.primaryTextColor
                ]}
              >
                {subTilte}
              </Text>
            )}
          </View>
        </View>
        {true && (
          <View style={[globalStyles.relativePosition, globalStyles.rn6]}>
            <Entypo
              name="chevron-right"
              size={24}
              color={colorPalette.secondary}
            />
          </View>
        )}
      </TouchableOpacity>
    )
  }
  const paycheckstore = usepaycheckStore()
  const initializeStore = useInitializeStore()
  useEffect(() => {
    paycheckstore.getEmployeeResources(
      initializeStore.initializeData.mostRecentUserOnBoardings
    )
  }, [])
  const { t } = useTranslation()
  const homeStore = useHomeStore()



  //   // Open a blank tab immediately
  //   const newWindow = window.open('', '_blank');

  //   if (!newWindow) {
  //     alert("Please allow pop-ups for this website.");
  //     return;
  //   }

  //   // Write a basic HTML loader into the new window
  //   newWindow.document.write(`
  //     <html>
  //       <head>
  //         <title>Loading PDF...</title>
  //         <style>
  //           body {
  //             font-family: Arial, sans-serif;
  //             display: flex;
  //             align-items: center;
  //             justify-content: center;
  //             height: 100vh;
  //             margin: 0;
  //           }
  //           .loader {
  //             font-size: 1.2rem;
  //             color: #444;
  //           }
  //         </style>
  //       </head>
  //       <body>
  //         <div class="loader">Loading PDF, please wait...</div>
  //       </body>
  //     </html>
  //   `);
  //   newWindow.document.close(); // Important to allow loading to complete

  //   try {
  //     const response = await paycheckstore.getpdfbase64(storepolicykey);

  //     if (response?.uri) {
  //       const base64 = response.uri;
  //       const byteCharacters = atob(base64.split(',')[1] || base64);
  //       const byteArrays = [];

  //       for (let offset = 0; offset < byteCharacters.length; offset += 512) {
  //         const slice = byteCharacters.slice(offset, offset + 512);
  //         const byteNumbers = new Array(slice.length);
  //         for (let i = 0; i < slice.length; i++) {
  //           byteNumbers[i] = slice.charCodeAt(i);
  //         }
  //         const byteArray = new Uint8Array(byteNumbers);
  //         byteArrays.push(byteArray);
  //       }

  //       const blob = new Blob(byteArrays, { type: 'application/pdf' });
  //       const blobUrl = URL.createObjectURL(blob);

  //       // Load the PDF directly in the same window
  //       newWindow.location.href = blobUrl;

  //       setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
  //     } else {
  //       newWindow.document.body.innerHTML = '<p>Failed to load PDF.</p>';
  //     }
  //   } catch (error) {
  //     console.error('Error:', error);
  //     newWindow.document.body.innerHTML = '<p>An error occurred while loading the PDF.</p>';
  //   }
  // };

  const handleView = async (storepolicykey) => {
    try {
      const response = await paycheckstore.getpdfbase64(storepolicykey);

      if (response?.uri) {
        const base64 = response.uri.split(',')[1] || response.uri;
        const byteCharacters = atob(base64);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
          const slice = byteCharacters.slice(offset, offset + 512);
          const byteNumbers = Array.from(slice).map(c => c.charCodeAt(0));
          byteArrays.push(new Uint8Array(byteNumbers));
        }

        const blob = new Blob(byteArrays, { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);

        // Open in new tab
        window.open(blobUrl, '_blank');

        // Revoke the URL after some time
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
      }
    } catch (error) {
      console.error('Error opening PDF:', error);
    }
  };
  const getFilterdPdfs = useMemo(() => {
    return paycheckstore.resourceData?.data?.pdfs?.filter(
      item => item.onboardingEmployee === true
    );
  }, [paycheckstore.resourceData?.data?.pdfs]);

  const getFilterdLinks = useMemo(() => {
    return paycheckstore.resourceData?.data?.externallinks?.filter(
      item => item.onboardingEmployee === true
    );
  }, [paycheckstore.resourceData?.data?.externallinks])
  let isOnboarded = homeStore?.homeData?.isOnboarded;

  let filteredlinks: any = [];
  filteredlinks = isOnboarded ? paycheckstore.resourceData?.data?.externallinks : getFilterdLinks
  let filteredPdfs: any = [];
  filteredPdfs = isOnboarded ? paycheckstore.resourceData?.data?.pdfs : getFilterdPdfs;



  if (paycheckstore.error) return <ScreenStatus message={paycheckstore.error} />

  return (
    <ScrollView>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader />
        </View>
        <View style={[globalStyles.vCenterItems]}>
          <Text
            style={[
              globalStyles.text,
              globalStyles.fwBold,
              globalStyles.fs30,
              globalStyles.whiteTextColor,
              globalStyles.textCenter
            ]}
          >
            {/* {t('Employee Resources')} */}
            {homeStore?.homeData?.isOnboarded ? t('Employee Resources') : t('Employee Onboarding Resources')}
          </Text>
        </View>
      </View>
      {paycheckstore.loading ? (
        <View style={[globalStyles.containerOverlap]}>
          <Card>
            <ActivityIndicator size={'large'} />
          </Card>
        </View>
      ) : (
        <View style={[globalStyles.containerOverlap]}>
          {filteredlinks?.length > 0 ||
            filteredPdfs?.length > 0 ? (
            <>
              <Card>
                {filteredlinks?.length > 0 ? (
                  <>
                    <View style={[boardStyles.boardCategory, { backgroundColor: "#fff" }]}>
                      <Text
                        style={[
                          globalStyles.text,
                          globalStyles.fwBold,
                          globalStyles.primaryTextColor
                        ]}
                      >
                        {t('External Links')}
                      </Text>
                    </View>
                    {filteredlinks?.map(
                      (item, index) => {
                        return (
                          <View key={index} style={{ margin: 5 }}>
                            <CardProfile
                              title={item.policyName}
                              subTilte={item.policyDescription}
                              icon={'external-link'}
                              action={() => {
                                Linking.openURL(item.filePath)
                              }}
                            />
                          </View>
                        )
                      }
                    )}
                  </>
                ) : (
                  <>
                    <View
                      style={{ justifyContent: 'center', alignItems: 'center' }}
                    >
                      <Text style={{ fontWeight: 'bold' }}>
                        {t('No External Links Available')}
                      </Text>
                    </View>
                  </>
                )}
              </Card>
              <Card>
                {filteredPdfs?.length > 0 ? (
                  <>
                    <View style={[boardStyles.boardCategory, { backgroundColor: "#fff" }]}>
                      <Text
                        style={[
                          globalStyles.text,
                          globalStyles.fwBold,
                          globalStyles.primaryTextColor
                        ]}
                      >
                        {t('PDFs')}
                      </Text>
                    </View>
                    {filteredPdfs?.map(
                      (item, index) => {

                        return (

                          <View key={index} style={{ margin: 5 }}>
                            <CardProfile2
                              title={item.policyName}
                              subTilte={item.policyDescription}
                              icon={'file-pdf-o'}
                              policy={item?.storepolicykey}
                            // action={() => {
                            //   // Linking.openURL(item.filePath)
                            //   handleView(item?.storepolicykey)
                            // }}
                            />
                          </View>

                        )
                      }
                    )}
                  </>
                ) : (
                  <>
                    <View
                      style={{ justifyContent: 'center', alignItems: 'center' }}
                    >
                      <Text style={{ fontWeight: 'bold' }}>
                        {t('No Pdfs Available')}
                      </Text>
                    </View>
                  </>
                )}
              </Card>
            </>
          ) : (
            <Card>
              <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                <Text style={{ fontWeight: 'bold' }}>{t('No Data Found')}</Text>
              </View>
            </Card>
          )}
        </View>
      )}
    </ScrollView>
  )
}
const styles = StyleSheet.create({
  CardProfile: {
    backgroundColor: colorPalette.light,
    padding: 16,
    borderRadius: 8
  }
})
export default EmployeeResources
